import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Spin } from "antd";
import axios from "axios";
import "./vleEarning.scss";
const BASE_URL = process.env.REACT_APP_CSC_API_BASE_URL;


const columns = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    width: 70,
    align: "center",
  },
  {
    title: "Agent Id",
    dataIndex: "agentId",
    key: "agentId",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Today Earnings",
    dataIndex: "todayEarnings",
    key: "todayEarnings",
  },
    {
    title: "Total Earnings",
    dataIndex: "lifetimeEarnings",
    key: "lifetimeEarnings",
  },

];

const VleEarnings = () => {
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState(""); 
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const [search, setSearch] = useState("");
  const searchRef = useRef();

  // Fetch VLE data
  const fetchVleData = async (page = 1, pageSize = 10, searchText = "") => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}api/vle/earnings`,
        {
          params: {
            page,
            limit: pageSize,
            search: searchText,
          },
        }
      );
      const vleData = res.data.data || [];
      // console.log("VLE Data:", vleData);
      setData(
        vleData.map((item, idx) => ({
          ...item,
          index: (page - 1) * pageSize + idx + 1,
        }))
      );
      setTotalData(res.data || 0);
    } catch (err) {
      setData([]);
      setTotalData(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVleData(tableParams.current, tableParams.pageSize, search);
    // eslint-disable-next-line
  }, [tableParams.current, tableParams.pageSize, search]);

  // Debounced search
const handleSearch = (e) => {
  const value = e.target.value;
  setSearchInput(value);
  if (searchRef.current) clearTimeout(searchRef.current);
  searchRef.current = setTimeout(() => {
    setSearch(value); // Only update search after debounce
    setTableParams((prev) => ({ ...prev, current: 1 }));
  }, 500);
};

  const handleTableChange = (pagination) => {
    setTableParams({
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  return (
    <div className="mainContain">
      <h1 className="transaction">All VLE Earning</h1>
      <div style={{ marginBottom: 16, maxWidth: 300 }}>
        <Input.Search
          placeholder="Search VLE"
          allowClear
          value={searchInput}
          onChange={handleSearch}
          style={{ width: "100%" }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="vleId"
        pagination={{
          total: totalData.total || 0,
          current: tableParams.current,
          pageSize: totalData.count || tableParams.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "50", "100", "200"],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        }}
        onChange={handleTableChange}
        scroll={{ x: 600 }}
      />
    </div>
  );
};

export default VleEarnings